var React = require('react');

function PatternCircles (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"136.558","cy":"209.187","r":"23.61","transform":"rotate(-165 136.558 209.187)","fill":"#3C4652","key":0}),React.createElement("circle",{"cx":"57.27","cy":"74.5271","r":"23.61","transform":"rotate(-165 57.27 74.5271)","fill":"#3C4652","key":1}),React.createElement("circle",{"cx":"68.3732","cy":"149.853","r":"16.0548","transform":"rotate(-165 68.3732 149.853)","fill":"#3C4652","key":2}),React.createElement("circle",{"cx":"177.133","cy":"57.7588","r":"23.61","transform":"rotate(-165 177.133 57.7588)","fill":"#3C4652","key":3})]);
}

PatternCircles.defaultProps = {"width":"207","height":"239","viewBox":"0 0 207 239","fill":"none"};

module.exports = PatternCircles;

PatternCircles.default = PatternCircles;
